import React, { useRef, useState } from 'react';
import './Bottom.scss';
import { Text } from '../text/Text.tsx';
import IAbout from '../../resource/about.png';
import ICD from '../../resource/cd.png';
import ISkills from '../../resource/skills.png';
import IHistory from '../../resource/history.png';
import { Skills } from '../menu/Skills.tsx';
import { History } from '../menu/History.tsx';
import { GridItem } from '../menu/interface.ts';
import { Popup } from '../home/popup/Popup.tsx';
import { AboutPopup } from '../home/popup/About.tsx';
import { BoredRadio } from '../home/popup/BoredRadio.tsx';

export const Bottom: React.FC = () => {
  const [skills, setSkills] = useState<boolean>(false);
  const [history, setHistory] = useState<boolean>(false);
  const [detail, setDetail] = useState<GridItem | undefined>(undefined);
  const [aboutUs, setAboutUs] = useState<boolean>(false);
  const [boredRadio, setBoredRadio] = useState<boolean>(false);
  return (
    <div className="bottom">
      <div />
      <div className="bottom-content">
        <div
          className="button"
          onClick={() => {
            setSkills(!skills);
            setHistory(false);
            setDetail(undefined);
          }}
        >
          <div style={{ width: 20, height: 20 }}>
            <img
              src={ISkills}
              alt="Retro computer"
              style={{ width: 20 }}
              loading="lazy"
            />
          </div>
          <Text variant="body">Skills</Text>
        </div>
        <div
          className="button"
          style={{ marginLeft: 4 }}
          onClick={() => {
            setHistory(!history);
            setSkills(false);
            setDetail(undefined);
          }}
        >
          <div style={{ width: 20, height: 20 }}>
            <img
              src={IHistory}
              alt="Retro computer"
              style={{ width: 20 }}
              loading="lazy"
            />
          </div>
          <Text variant="body">Projects</Text>
        </div>
        {/* <div
          className="button"
          style={{ marginLeft: 4 }}
          onClick={() => {
            setBoredRadio(!boredRadio);
          }}
        >
          <div style={{ width: 20, height: 20 }}>
            <img
              src={ICD}
              alt="Retro computer"
              style={{ width: 20 }}
              loading="lazy"
            />
          </div>
          <Text variant="body">Radio</Text>
        </div> */}
        <div className="button"
          style={{ marginLeft: 4 }}
          onClick={() => setAboutUs(!aboutUs)}>
          <div style={{ width: 20, height: 20 }}>
            <img
              src={IAbout}
              alt="Retro computer"
              style={{ width: 20 }}
              loading="lazy"
            />
          </div>
          <Text variant="body">About</Text>
        </div>
      </div>

      {skills && (
        <div
          className="popup-content"
          onClick={() => {
            setSkills(false);
            setHistory(false);
          }}
        >
          <Skills />
        </div>
      )}

      {history && (
        <div
          className="popup-content"
          onClick={() => {
            setSkills(false);
            setHistory(false);
          }}
        >
          <History
            onClick={(item) => {
              setDetail(item);
            }}
          />
        </div>
      )}

      {detail && (
        <div
          className="popup-content"
          onClick={() => {
            setSkills(false);
            setHistory(false);
            setDetail(undefined);
          }}
        >
          <Popup
            allowFull={true}
            title={detail.title}
            content={detail.content}
            onClose={function (): void {
              setDetail(undefined);
            }}
          />
        </div>
      )}

      {aboutUs && (
        <div
          className="popup-content"
          onClick={() => {
            setSkills(false);
            setHistory(false);
            setDetail(undefined);
          }}
        >
          <AboutPopup
            onClose={function (): void {
              setAboutUs(false);
            }}
          />
        </div>
      )}

      {boredRadio && (
        <div
          className="popup-content"
          onClick={() => {
          }}
        >
          <BoredRadio
            onClose={function (): void {
              setBoredRadio(false);
            }}
          />
        </div>
      )}
    </div>
  );
};
